import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { ChartLegendColor, ChartLegendContainer, ChartLegendItem, ChartLegendName } from "./styled";
import { LegendToggler } from "../../../LayerList/styled";
import { FILTERED_VALUE_OPACITY } from "../../constants";
import { useFeatureFilters } from "../../hooks/useFeatureFilters";
import { useShownOtherItems } from "../../hooks/useShownOtherItems";
import { ConfigContainerChild, ConfigOptions, PieChartDisplayedData, WidgetType } from "../../types";

export const ChartLegend: FC<{
  data: PieChartDisplayedData;
  chartElement?: ConfigContainerChild;
  type: WidgetType;
  twoColumns: boolean;
  loading: boolean;
}> = ({ data, chartElement, type, twoColumns, loading }) => {
  const { t } = useTranslation("common");
  const { sliceItems, showMore, onShowMore } = useShownOtherItems(chartElement?.options);

  const axes = useMemo(
    () => chartElement?.options?.relatedDataSources?.filter(({ chartAxis }) => chartAxis === "y"),
    [chartElement?.options?.relatedDataSources],
  );

  const { isFiltered, hasAnyFilter, onFilter } = useFeatureFilters(type, axes?.[0]?.filterName);

  const { fontColor, shownItems, hideEmpty } = (chartElement?.options as ConfigOptions) || ({} as ConfigOptions);
  const showMoreBtn = !!shownItems && data.length > shownItems;

  if (!loading && !data?.length && hideEmpty) return null;

  return (
    <div style={{ opacity: loading ? FILTERED_VALUE_OPACITY / 100 : 1 }}>
      <ChartLegendContainer twoColumns={twoColumns}>
        {sliceItems(data)?.map(({ name, color }, index) => (
          <ChartLegendItem
            key={index}
            hasAnyFilter={hasAnyFilter}
            isFiltered={isFiltered(name as string)}
            onClick={axes?.[0]?.filterName ? () => onFilter(name as string) : undefined}
          >
            <ChartLegendColor color={color} />
            <ChartLegendName $fontColor={fontColor}>{name}</ChartLegendName>
          </ChartLegendItem>
        ))}
      </ChartLegendContainer>
      {showMoreBtn && (
        <LegendToggler onClick={onShowMore} toggled={showMore}>
          {t("other")}
        </LegendToggler>
      )}
    </div>
  );
};
